import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";
import UserIcon from "@material-ui/icons/PersonOutline";
import HeartIcon from "@material-ui/icons/FavoriteBorderSharp";
import { WidgetProps } from "../widgets";
import aboutImg from "../../assets/tempImages/aboutImg.png";
import { ImageWithLayersBG } from "../ui/Media/ImageWithLayersBG";
import ImageEnlarge from "../ui/Media/ImageEnlarge";
import { IImage } from "../../models/Image";
import { FileType } from "../../laco-common/base/models/IFile";
import { OrangeArrowLink } from "./HomeBlue";

// aboutImg.png
type BenefitsWidgetProps = {} & WidgetProps;

const services: { title: string; desc: string; icon: any; imageUrl?: string; url?: string; linkText: string }[] = [
	{
		title: "The Benefit Fund",
		desc: "The B&W is able to host several recreational activities that brings firefighters and their families together throughout the year, thanks to the Benefit Fund.",
		icon: <UserIcon color="primary" />,
		// url: "/membership",
		linkText: "More Info",
	},
	{
		title: "The Welfare Fund",
		desc: "The purpose of this fund is to provide various care for our firefighters and their families.",
		icon: <HeartIcon color="primary" />,
		// url: "/donate",
		linkText: "More Info",
	},
	{
		title: "Membership Benefits",
		desc: "We provide our B&W members several benefits including access to mental health resources, medical equipment and much more.",
		icon: <UserIcon color="primary" />,
		url: "/membership",
		linkText: "More Info",
	},
];

export const AboutBlueWidget: React.FC<BenefitsWidgetProps> = (props: BenefitsWidgetProps) => {
	// const [Component, setComponent] = useState<any>(null);

	useEffect(() => {}, []);

	const media: IImage = {
		filename: "",
		fileType: FileType.IMAGE,
		url: "https://firebasestorage.googleapis.com/v0/b/la-county-fire-dep.appspot.com/o/site%2Fmedia%2Faboutpage.jpeg?alt=media",
	}; //getSiteMedia();

	return (
		<div className="container section-padding">
			<div className="header-title-content container-fluid align-self-stretch flex-grow-1 d-flex flex-column justify-content-center">
				<div className="container">
					<div className="header-title-content-inner d-flex flex-column flex-md-row align-items-center flex-equal-width-container">
						<div className="header-text-container">
							<h3 className="subheading text-uppercase text-primary">Welcome Home!</h3>
							<h2 style={{ fontSize: "1.7rem", lineHeight: 1.4 }} className="mb-3">
								We are a Community and Helping Hand to our Firefighters
							</h2>
							<p style={{ fontSize: "14px" }}>
								The Los Angeles County Firemen's Benefit & Welfare Association is a non-profit
								organization founded and administered by its members. We welcome both active and retired
								employees of the LACoFD.
							</p>
							<p style={{ fontSize: "14px" }}>
								Our community is driven by firefighters and families. First and foremost, we are here to
								care for one another. We welcome you here to explore the many benefits our community
								offers. From fun social gatherings, medical equipment, health and welfare benefits,
								community connections, to mental health resources - there is something here for you.
							</p>
						</div>
						<div className="header-inner-image section-padding1">
							<ImageWithLayersBG url={aboutImg} />
						</div>
					</div>
				</div>
			</div>

			{/*<div className="section-cards">*/}
			{/*	<div className="card bg-light">*/}
			{/*		<h2>test</h2>*/}
			{/*		<div className="card-body">hello</div>*/}
			{/*	</div>*/}
			{/*</div>*/}

			<div className="my-5">
				<h1 className="text-center">What We Provide</h1>
			</div>
			<div className="cards-container cards-3 w-blue-box">
				{services.map(({ title, desc, imageUrl, icon, url, linkText }, i) => {
					const card = (
						<div className="card bg-light" key={i}>
							<div className="card-body">
								<span className="card-icon position-relative">{icon}</span>
								<h4 className="card-title">{title}</h4>
								<p className="card-text" style={{ fontSize: "15px" }}>
									{desc}
								</p>
								{!!url && <OrangeArrowLink text={linkText} url={url} />}
							</div>
						</div>
					);
					if (url)
						return (
							<NavLink to={url} key={i} className="scale-in-image-view d-inline-block">
								{card}
							</NavLink>
						);
					else
						return (
							<span key={i} className="d-inline-block">
								{card}
							</span>
						);
				})}
			</div>
			<div className="blue-box">
				<div className="d-flex flex-column-reverse flex-lg-row justify-content-between align-items-stretch flex-equal-width-container">
					<div className="align-self-stretch flex-grow-1 pr-7 pr-0-mobile-tablet">
						<ImageEnlarge image={media} isPercentage imageWidth100Pct scaleInEffect />
					</div>
					<div>
						<h1>The Benefit Fund</h1>
						<p className="py-2">
							This fund provides social and recreational activities for members such as:
						</p>
						<ul className="checkmark-list-new">
							<li className="Yes">Straight Streams Magazine</li>
							<li className="Yes">L.A. County Firefighter's Picnic</li>
							<li className="Yes">
								Subsidy for a portion of retirees’ admission to qualified retirement functions
							</li>
							<li className="Yes">Discounted admission to local and national entertainment venues</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	);
};
